<!-- Loading indicator when fetching agent from route parameters -->
@if (loadingAgent) {
  <div class="text-center py-4">
    <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
    <p class="mt-2">Chargement des données de l'agent...</p>
  </div>
}

@if (!loadingAgent) {
  <form [formGroup]="situationAdministrativeForm" (ngSubmit)="onSubmit()">
    <fieldset>
      <legend class="custom-legend">Situation administrative de l'agent</legend>
      <!-- Agent et Type de recrutement -->
      <div class="row">
        <div class="col-6">
          <div class="row">
            <mat-label for="agent" class="label col-6 col-form-label">Agent *</mat-label>
            <div class="form-text mb-1">Sélectionnez l'agent.</div>
            <mat-form-field class="w-100">
              <input
                #autoCompleteAgent
                type="text"
                aria-label="Nom Prénom"
                matInput
                name="item"
                [matAutocomplete]="auto"
                formControlName="agent"
                (input)="agentFilter($event)"
                [(ngModel)]="val_ft_agent"
                />
                @if (val_ft_agent && !situationAdministrativeForm.get('agent')?.disabled) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="effaceAgentFiltre($event, 'agent')"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
                <mat-autocomplete
                  #auto="matAutocomplete"
                  hideSingleSelectionIndicator
                  requireSelection
                  [displayWith]="agentdisplayFn"
                  (optionSelected)="onAgentSelect($event)"
                  >
                  @for (agent of filteredOptions; track agent) {
                    <mat-option [value]="agent"> {{ agent.nom }} {{ agent.prenom }} </mat-option>
                  }
                </mat-autocomplete>
                @if (situationAdministrativeForm.get('agent')?.hasError('required') && situationAdministrativeForm.get('agent')?.touched) {
                  <mat-error
                    >
                    L'agent est requis.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <mat-label for="typeRenouvellement" class="label col-6 col-form-label">Type de renouvellement *</mat-label>
              <div class="form-text mb-1">Sélectionnez le type de renouvellement.</div>
              <mat-form-field class="w-100">
                <input
                  type="text"
                  matInput
                  aria-label="Type de renouvellement"
                  name="Type de renouvellement"
                  [matAutocomplete]="autoTyperenouvellement"
                  formControlName="typeRenouvellement"
                  (input)="filterRenouvellementList($event)"
                  [(ngModel)]="val_ft_type_renouvellement"
                  />
                  @if (val_ft_type_renouvellement && !situationAdministrativeForm.get('typeRenouvellement')?.disabled) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="effaceFiltreTypeRen($event, 'typeRenouvellement')"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  <mat-autocomplete
                    hideSingleSelectionIndicator
                    requireSelection
                    #autoTyperenouvellement="matAutocomplete"
                    [displayWith]="typeRenouvellementdisplayFn"
                    >
                    @for (type of recrutementListFiltered; track type) {
                      <mat-option [value]="type">
                        {{ type.libelle }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  @if (
                    situationAdministrativeForm.get('typeRenouvellement')?.hasError('required') &&
                    situationAdministrativeForm.get('typeRenouvellement')?.touched
                    ) {
                    <mat-error
                      >
                      Le type de renouvellement est requis.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- Catégorie du poste et Identifiant agent -->
          <div class="row">
            <div class="col-6">
              <label for="categoriePoste" class="label col-6 col-form-label">Catégorie du poste</label>
              <div class="form-text mb-1">Sélectionnez la catégorie du poste.</div>
              <mat-form-field class="w-100">
                <mat-select formControlName="categoriePoste">
                  @for (categorie of categoriePosteList; track categorie) {
                    <mat-option [value]="categorie.id">
                      {{ categorie.code }}
                    </mat-option>
                  }
                </mat-select>
                @if (val_ft_categorie_poste && !situationAdministrativeForm.get('categoriePoste')?.disabled) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="effaceFiltreCategoriePoste($event, 'categoriePoste')"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
                <!-- categoriePoste is never required per business rules -->
              </mat-form-field>
            </div>
            <div class="col-6">
              <label for="identifiantAgent" class="label col-6 col-form-label">Identifiant agent *</label>
              <div class="form-text mb-1">Sélectionnez l'identifiant de l'agent.</div>
              <mat-form-field class="w-100">
                <mat-select formControlName="identifiantAgent" required>
                  @for (agent of filteredOptions; track agent) {
                    <mat-option [value]="agent" [value]="agent.identifiant">
                      {{ agent.identifiant }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  situationAdministrativeForm.get('identifiantAgent')?.hasError('required') &&
                  situationAdministrativeForm.get('identifiantAgent')?.touched
                  ) {
                  <mat-error
                    >
                    L'identifiant de l'agent est requis.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <!-- Grade et Entrée dans l'organisation -->
          <div class="row">
            <div class="col-6">
              <label for="grade" class="label col-6 col-form-label">Grade *</label>
              <div class="form-text mb-1">Sélectionnez le grade.</div>
              <mat-form-field class="w-100">
                <mat-select formControlName="grade" required>
                  @for (agent of filteredOptions; track agent) {
                    <mat-option [value]="agent" [value]="agent.grade">
                      {{ agent.grade }}
                    </mat-option>
                  }
                </mat-select>
                @if (situationAdministrativeForm.get('grade')?.hasError('required') && situationAdministrativeForm.get('grade')?.touched) {
                  <mat-error
                    >
                    La grade est requise.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-6">
              <div class="row">
                <label for="dateEntree" id="label-entreeOrganisation" class="label col-6 col-form-label">Entrée dans l'organisation *</label>
                <div class="form-text mb-1">Sélectionnez ou saisissez une date au format DD/MM/YYYY.</div>
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="entreeOrganisationDatePicker" type="text" formControlName="dateEntree" required />
                  <mat-datepicker-toggle matSuffix [for]="entreeOrganisationDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #entreeOrganisationDatePicker></mat-datepicker>
                  @if (
                    situationAdministrativeForm.get('dateEntree')?.hasError('required') &&
                    situationAdministrativeForm.get('dateEntree')?.touched
                    ) {
                    <mat-error
                      >
                      La date de l'entrée dans l'organisation est requise.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- Poste occupé et Taux emploi -->
          <div class="row">
            <div class="col-6">
              <label for="posteOccupe" class="label col-6 col-form-label">Poste occupé *</label>
              <div class="form-text mb-1">Sélectionnez le poste occupé.</div>
              <mat-form-field class="w-100">
                <mat-select formControlName="posteOccupe" required>
                  @for (poste of posteList; track poste) {
                    <mat-option [value]="poste.id">
                      {{ poste.libelle }}
                    </mat-option>
                  }
                </mat-select>
                @if (val_ft_poste && !situationAdministrativeForm.get('posteOccupe')?.disabled) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="effaceFiltrePoste($event, 'posteOccupe')"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
                @if (
                  situationAdministrativeForm.get('posteOccupe')?.hasError('required') &&
                  situationAdministrativeForm.get('posteOccupe')?.touched
                  ) {
                  <mat-error
                    >
                    Le poste occupé est requis.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-6">
              <label for="tauxEmploi" class="label col-6 col-form-label">Taux d'emploi *</label>
              <div class="form-text mb-1">Saisissez le taux de l'emploi (50%, 100% ...).</div>
              <mat-form-field class="w-100">
                <input matInput formControlName="tauxEmploi" required />
                @if (
                  situationAdministrativeForm.get('tauxEmploi')?.hasError('required') && situationAdministrativeForm.get('tauxEmploi')?.touched
                  ) {
                  <mat-error
                    >
                    Le taux d'emploi est requis.
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <!-- Fonction de l'agent -->
          <div class="row">
            <div class="col-6">
              <label for="fonction" class="label col-6 col-form-label">Fonction de l'agent *</label>
              <div class="form-text mb-1">Sélectionnez la fonction de l'agent.</div>
              <mat-form-field class="w-100">
                <mat-select formControlName="fonction" required>
                  @for (agent of filteredOptions; track agent) {
                    <mat-option [value]="agent.fonction">
                      {{ agent.fonction }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  situationAdministrativeForm.get('fonction')?.hasError('required') && situationAdministrativeForm.get('fonction')?.touched
                  ) {
                  <mat-error
                    >
                    La fonction de l'agent est requise.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-6">
              <label for="tauxEmploi" class="label col-6 col-form-label">Date d'expiration de la carte de séjour</label>
              <div class="form-text mb-1">Date d'expiration carte de séjour, format date DD/MM/YYYY.</div>
              <mat-form-field class="w-100">
                <input matInput [disabled]="true" [value]="dateExpirationCS" />
              </mat-form-field>
            </div>
          </div>
          <mat-divider class="divider"></mat-divider>
          <div class="row">
            <!-- Pole et Direction -->
            <div class="col-6">
              <div class="row">
                <label for="pole" id="label-pole" class="label col-6 col-form-label">Pole *</label>
                <div class="form-text mb-1">Sélectionnez le pole (Famille, attractivité et cohésion ...).</div>
                <mat-form-field class="w-100">
                  <mat-select formControlName="pole" required>
                    @for (pole of poleList; track pole) {
                      <mat-option [value]="pole.id">{{ pole.libelle }}</mat-option>
                    }
                  </mat-select>
                  @if (val_ft_pole && !situationAdministrativeForm.get('pole')?.disabled) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="effaceFiltrePole($event, 'pole')"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  @if (situationAdministrativeForm.get('pole')?.hasError('required') && situationAdministrativeForm.get('pole')?.touched) {
                    <mat-error
                      >
                      Le pole est requis.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <label for="direction" id="label-etat" class="label col-6 col-form-label">Direction *</label>
                <div class="form-text mb-1">Sélectionnez la direction.</div>
                <mat-form-field class="w-100">
                  <input
                    #autoCompleteDirection
                    type="text"
                    aria-label="Direction"
                    matInput
                    [matAutocomplete]="autoDirectionHS"
                    formControlName="direction"
                    (input)="directionFilter($event)"
                    [(ngModel)]="val_ft_direction"
                    />
                    @if (val_ft_direction && !situationAdministrativeForm.get('direction')?.disabled) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="effaceDirectionFiltre($event, 'direction')"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    <mat-autocomplete cdkScrollable #autoDirectionHS="matAutocomplete" [displayWith]="directiondisplayFn">
                      @for (item of directionList; track item) {
                        <mat-option [value]="item">{{ item.libelle }}</mat-option>
                      }
                    </mat-autocomplete>
                    @if (
                      situationAdministrativeForm.get('direction')?.hasError('required') && situationAdministrativeForm.get('direction')?.touched
                      ) {
                      <mat-error
                        >
                        La direction est requise.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Service ou unité de rattachement et Type de contrat-->
              <div class="col-6">
                <label for="serviceFonctionnel" class="label col-6 col-form-label">Service ou unité de rattachement</label>
                <div class="form-text mb-1">Sélectionnez le service ou unité de rattachement.</div>
                <mat-form-field class="w-100">
                  <input
                    #autoCompleteService
                    type="text"
                    aria-label="serviceFonctionnel"
                    matInput
                    [matAutocomplete]="autoService"
                    formControlName="serviceFonctionnel"
                    (input)="serviceFilter($event)"
                    [(ngModel)]="val_ft_service"
                    />
                    @if (val_ft_service && !situationAdministrativeForm.get('serviceFonctionnel')?.disabled) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="effaceFiltreService($event, 'serviceFonctionnel')"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    <mat-autocomplete #autoService="matAutocomplete" hideSingleSelectionIndicator requireSelection [displayWith]="servicedisplayFn">
                      @for (element of serviceList; track element) {
                        <mat-option [value]="element">{{ element.libelle }}</mat-option>
                      }
                    </mat-autocomplete>
                    @if (
                      situationAdministrativeForm.get('serviceFonctionnel')?.hasError('required') &&
                      situationAdministrativeForm.get('serviceFonctionnel')?.touched
                      ) {
                      <mat-error
                        >
                        Le service est requis.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <label for="typeContrat" class="label col-6 col-form-label">Type de contrat *</label>
                  <div class="form-text mb-1">Sélectionnez le type de contrat.</div>
                  <mat-form-field class="w-100">
                    <mat-select formControlName="typeContrat" required>
                      @for (typeContrat of typeContratList; track typeContrat) {
                        <mat-option [value]="typeContrat.id">
                          {{ typeContrat.libelle }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (val_ft_type_contrat && !situationAdministrativeForm.get('typeContrat')?.disabled) {
                      <button
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="effaceFiltreTypeContrat($event, 'typeContrat')"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    @if (
                      situationAdministrativeForm.get('typeContrat')?.hasError('required') &&
                      situationAdministrativeForm.get('typeContrat')?.touched
                      ) {
                      <mat-error
                        >
                        Le type de contrat est requis.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <!-- Agent remplacé et Début - Fin contrat-->
                <div class="col-6">
                  <label for="agentRemplace" class="label col-6 col-form-label">Agent remplacé *</label>
                  <div class="form-text mb-1">Sélectionnez (oui, non).</div>
                  <mat-form-field class="w-100">
                    <mat-select formControlName="agentRemplace" required>
                      <mat-option value="true">Oui</mat-option>
                      <mat-option value="false">Non</mat-option>
                    </mat-select>
                    @if (
                      situationAdministrativeForm.get('agentRemplace')?.hasError('required') &&
                      situationAdministrativeForm.get('agentRemplace')?.touched
                      ) {
                      <mat-error
                        >
                        L'agent remplacé est requis.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <label for="debutFinContrat" class="label col-6 col-form-label">Début - Fin contrat *</label>
                  <div class="form-text mb-1">Sélectionnez ou saisissez date début - fin contrat, format date DD/MM/YYYY.</div>
                  <mat-form-field class="w-100">
                    <mat-date-range-input [rangePicker]="picker">
                      <input matStartDate formControlName="dateDebutContrat" type="text" />
                      <input matEndDate formControlName="dateFinContrat" type="text" />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    @if (
                      !situationAdministrativeForm.hasError('datesManquantes') &&
                      situationAdministrativeForm.get('dateDebutContrat')?.hasError('required')
                      ) {
                      <mat-error
                        >
                        La date de début est requise.
                      </mat-error>
                    }
                    @if (
                      !situationAdministrativeForm.hasError('datesManquantes') &&
                      situationAdministrativeForm.get('dateFinContrat')?.hasError('required')
                      ) {
                      <mat-error
                        >
                        La date de fin est requise.
                      </mat-error>
                    }
                    <!-- <mat-error *ngIf="situationAdministrativeForm.hasError('datesInvalide')">
                    Si vous sélectionnez une date de début, vous devez également sélectionner une date de fin.
                  </mat-error> -->
                  @if (situationAdministrativeForm.hasError('datesManquantes')) {
                    <mat-error>
                      Vous devez sélectionner à la fois une date de début et une date de fin de contrat.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </fieldset>
          <div class="button-group">
            <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
            <button mat-flat-button color="primary" type="submit" matStepperNext [disabled]="!situationAdministrativeForm.valid">Suivant</button>
          </div>
        </form>
      }
